import React, { useState } from "react";
import { Col, Input, Row } from "reactstrap";
import { api } from "../utils";
import { DesktopContainer } from "../layouts";
import { toast } from "react-toastify";
import { SpinnerButton } from './';

export default function ExplodeCase() {
   const [caseNumber, setCaseNumber] = useState("");
   const [isWorking, setIsWorking] = useState(false);

   function explodeCase() {
      setIsWorking(true);
      let payload = {
         LotNumber: caseNumber
      };

      api
         .post("Production/ExplodeCase", payload)
         .then((response) => {
            if (response && response.data.success) {
               toast.success("Explode Case successful.");
            } else {
               toast.error(response.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsWorking(false));
   }

   return (
      document.title = `Explode Case`,
      <DesktopContainer screenName="Explode Case">
         <Row className="mt-3 d-flex justify-content-center align-items-center filter-header">
            <Col xs="6">
               <Row className="mt-3 d-flex align-items-center">
                  <Col xs="3" className="d-flex justify-content-end">
                     <p className="m-0" style={{ color: "white", fontSize: "1.25rem" }}>Case Number:</p>
                  </Col>
                  <Col xs="7">
                     <Input
                        type="text"
                        value={caseNumber || ""}
                        onChange={(e) => setCaseNumber(e.target.value)}
                     />
                  </Col>
               </Row>
               <Row className="mt-3 d-flex align-items-center">
                  <Col xs="3">

                  </Col>
                  <Col xs="7">
                     <SpinnerButton
                        className="shredButton"
                        onClick={() => explodeCase()}
                        disabled={isWorking}
                        on={isWorking}
                     >
                        REMOVE CASE FROM INVENTORY
                     </SpinnerButton>
                  </Col>
               </Row>
            </Col>
         </Row>
      </DesktopContainer>
   );
}